import React, { useState, useEffect } from "react";
import { makeStyles, Typography, ButtonBase } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ClearIcon from "@material-ui/icons/Clear";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });
import { useSpring, animated, config } from "react-spring";
import useAnimation from "./../../../../animation";

import ExpandablePanel from "./expandablePanel/ExpandablePanel";
import LogoAnimation from "../../../../assets/logo.json";

const LogoAnimationOptions = {
  loop: false,
  autoplay: true,
  animationData: LogoAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function SubHeader({ commercialCategories, productTypes, reset }) {
  const classes = useStyle();
  const [openExpandablePanel, setOpenExpandablePanel] = useState(false);
  const [animation, setAnimation] = useState(null);
  const animate = useSpring({
    transform: `translateX(${animation ? "0" : "-150"}%) rotate(${animation ? 0 : -360}deg)`,
    opacity: animation ? "1" : "0",
    config: config.gentle,
  });
  useAnimation(animation, setAnimation);

  useEffect(() => {
    setOpenExpandablePanel(false);
  }, [reset, setOpenExpandablePanel]);

  return (
    <div className={classes.subHeader}>
      <animated.div style={animate} className={classes.homeIcon}>
        <a href="/" title="Murfy">
          <Lottie options={LogoAnimationOptions} height={55} width={80} className={classes.logo} />
        </a>
      </animated.div>

      <Typography component="div" className={classes.container}>
        <ButtonBase
          disableRipple
          className={classes.categoriesContainer}
          onClick={() => setOpenExpandablePanel((prev) => !prev)}
        >
          {openExpandablePanel ? <ClearIcon className={classes.menuIcon} /> : <MenuIcon className={classes.menuIcon} />}

          <Typography className={classes.expandable__button__text}>Tout notre électroménager durable</Typography>
        </ButtonBase>
      </Typography>
      <ExpandablePanel
        productTypes={productTypes}
        commercialCategories={commercialCategories}
        open={openExpandablePanel}
      />
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  subHeader: {
    top: 0,
    zIndex: 10,
    position: "sticky",
  },
  container: {
    backgroundColor: theme.palette.secondary.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    display: "flex",
    backfaceVisibility: "hidden",
    alignItems: "center",
    color: theme.palette.secondary.main,
    position: "relative",
  },
  categoriesContainer: {
    marginLeft: theme.spacing(10),
    borderRadius: 50,
    cursor: "pointer",
    color: "white",
    display: "flex",
    justifyContent: "center",
    transition: "all 150ms linear",
    padding: " 8px 16px",
    "&:hover": {
      boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
    },
  },

  homeIcon: {
    position: "absolute",
    top: theme.spacing(1),
    left: "2%",
    zIndex: 1,
  },
  menuIcon: {
    marginRight: theme.spacing(1),
    color: "white",
    fontSize: 25,
  },
  hover: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.7,
    },
  },
  expandable__button__text: {
    fontSize: 16,
  },
}));

export default SubHeader;
